import SchemeUtils from "../../utils/schemes";
import store from "../index";

const state = () => ({
  grants: [],
  selectedGrant: [{}],
  shortIntro: "",
  shareGrantItem: false,
  shareGrantsPage: false,
  grantToShare: [],
  schemeToDownload: [],
  schemeCustomers: [],
  grantsPageToShare: [],
  folderToDownload: [],
  nameOfDownloadFolder: "",
  selectedResults: [],
  selectedResultsCount: 0,
  selectedGrantMax: 0,
  selectedGrantMin: 0,
  newsInLastYear: [],
  olderNews: [],
  isSearchPageLoading: true,
  isSideBarLoading: true,
  numberOfResultsOnPage: 0,
  downloadScheme: false,
  downloadSchemeReport: false,
  downloadFolderReport: false,
  downloadSchemesPage: false,
  areGrantDetailsLoading: true,
  hasModalError: false,
  modalErrorMessage: "",
  newestGrants: [],
  deadlineGrants: [],
  significantChangesGrants: [],
  fundingCopy: [],
  administratingCopy: [],
  advisingCopy: [],
  recipientCopy: [],
  organisationsList: [],
  sortedLinksAndDocs: [],
  importantLinks: [],
  isDisplayDownloadMessage: false,
  labelForSaveModal: "Items opslaan",
  selectedTransBody: "",
  selectedTransCriteria: "",
  selectedTransApplicationProcedure: "",
  selectedTransIntroduction: "",
  selectedTransFinancialinformation: "",
  selectedTransName: "",
  translateScheme: false,
  selectedTransApplicationInformation: "",
  selectedTransDuration: "",
  selectedTransBudget: "",
  selectAllSchemesCheckBox: false,
  schemeStatuses: [],
  isLoadingNewestSchemes: false,
  isLoadingDeadlineSchemes: false,
  isLoadingLatestNews: false,
  timeScopeOptions: [],
  showConsultantDialog: false,
  schemeNameForConsultantContact: "",
});

const getters = {
  getAllGrants: (state) => {
    return state.grants;
  },

  getNumberOfRecords: (state) => {
    return state.grants.totalRecords;
  },
};

const actions = {};

const mutations = {
  updateShowConsultantDialog(state, val) {
    state.showConsultantDialog = val.value;
    if (val.schemeName != null && val.schemeName != "")
      state.schemeNameForConsultantContact = val.schemeName;
  },
  updateSelectAllSchemesCheckbox(state, val) {
    state.selectAllSchemesCheckBox = val;
  },
  updateSelectAllSchemesCheckboxBasedOnPagination(state, results) {
    state.selectAllSchemesCheckBox = results.every((result) =>
      state.selectedResults.map((x) => x.schemeId).includes(result),
    );
  },
  updateLabelForSaveModal(state, val) {
    state.labelForSaveModal =
      state.selectedResultsCount > 1 ? "Items opslaan" : val;
  },
  async updateisDisplayDownloadMessage(state) {
    const delay = (ms) => new Promise((res) => setTimeout(res, ms));

    state.isDisplayDownloadMessage = true;
    await delay(5000);
    state.isDisplayDownloadMessage = false;
  },
  updateNewestGrants(state, val) {
    state.newestGrants = val;
  },

  updateDeadlineGrants(state, val) {
    state.deadlineGrants = val;
  },

  updateSignificantChangesGrants(state, val) {
    state.significantChangesGrants = val;
  },
  enableDownloadScheme(state) {
    state.downloadScheme = true;
  },
  enableDownloadFolderReport(state, value) {
    var id = parseInt(value.id);
    state.nameOfDownloadFolder = value.name;
    state.folderToDownload = id;
    state.downloadFolderReport = true;
  },
  nameOfDownloadFolder(state, value) {
    state.nameOfDownloadFolder = value;
  },
  disableDownloadFolderReport(state) {
    state.downloadFolderReport = false;
  },
  enableDownloadSchemeReport(state, index) {
    var id = parseInt(index);
    state.downloadSchemeReport = true;
    state.schemeToDownload = id;
  },
  disableDownloadSchemeReport(state) {
    state.downloadSchemeReport = false;
  },
  disableDownloadScheme(state) {
    state.downloadScheme = false;
  },
  enableDownloadSchemesPage(state) {
    state.downloadSchemesPage = true;
  },
  disableDownloadSchemesPage(state) {
    state.downloadSchemesPage = false;
  },

  addSelected(state, index) {
    var id = parseInt(index);
    const wasSelected =
      state.selectedResults.filter((r) => r.schemeId == id).length > 0;

    if (!wasSelected) {
      state.selectedResults.push({
        schemeId: parseInt(id),
      });
    } else {
      const idx = state.selectedResults.map((r) => r.schemeId).indexOf(id);
      state.selectedResults.splice(idx, 1);
    }
    state.selectedResultsCount = state.selectedResults.length;
    store.commit("grantItems/updateLabelForSaveModal");
  },

  enableGrantDetailsLoading(state) {
    state.areGrantDetailsLoading = true;
  },

  disableGrantDetailsLoading(state) {
    state.areGrantDetailsLoading = false;
  },

  enableSearchPageLoading(state) {
    state.isSearchPageLoading = true;
  },
  disableSearchPageLoading(state) {
    state.isSearchPageLoading = false;
  },
  enableSideBarLoading(state) {
    state.isSideBarLoading = true;
  },
  disableSideBarLoading(state) {
    state.isSideBarLoading = false;
  },
  updateNewestSchemesLoading(state, value) {
    state.isLoadingNewestSchemes = value;
  },
  updateDeadlineSchemesLoading(state, value) {
    state.isLoadingDeadlineSchemes = value;
  },
  updateLatestNewsLoading(state, value) {
    state.isLoadingLatestNews = value;
  },

  clearSelectedResults(state) {
    state.selectedResults.length = 0;
    state.selectedResultsCount = 0;
    state.selectAllSchemesCheckBox = false;
    store.commit("grantItems/updateLabelForSaveModal");
  },

  selectAllFromPage(state) {
    for (let i = 0; i < state.grants.length; i++) {
      const wasSelected =
        state.selectedResults.filter((r) => r.schemeId == state.grants[i].id)
          .length > 0;
      if (!wasSelected)
        state.selectedResults.push({
          schemeId: parseInt(state.grants[i].id),
        });
    }
    state.selectedResultsCount = state.selectedResults.length;
    store.commit("grantItems/updateLabelForSaveModal");
  },

  deselectAllFromPage(state) {
    for (let i = 0; i < state.grants.length; i++) {
      const wasSelected =
        state.selectedResults.filter((r) => r.schemeId == state.grants[i].id)
          .length > 0;
      if (wasSelected) {
        const idx = state.selectedResults
          .map((r) => r.schemeId)
          .indexOf(parseInt(state.grants[i].id));

        state.selectedResults.splice(idx, 1);
      }
    }
    state.selectedResultsCount = state.selectedResults.length;
    store.commit("grantItems/updateLabelForSaveModal");
  },

  enableShareGrant(state, grant) {
    state.shareGrantItem = true;
    state.grantToShare = grant;
  },

  disableShareGrantItem(state, val) {
    state.shareGrantItem = val;
  },

  enableShareGrantsPage(state) {
    state.shareGrantsPage = true;
    state.grantsPageToShare = state.grants;
  },

  disableShareGrantsPage(state, val) {
    state.shareGrantsPage = val;
  },

  updateGrants(state, grantsData) {
    state.grants = grantsData.results;
  },

  updateSchemeCustomers(state, val) {
    state.schemeCustomers = val;
  },
  removeElementFromAdvisingCopy(state, id) {
    for (let i = 0; i < state.advisingCopy.length; i++) {
      if (state.advisingCopy[i].id == id) state.advisingCopy.splice(i, 1);
    }
  },
  removeElementFromARecipientCopy(state, id) {
    for (let i = 0; i < state.recipientCopy.length; i++) {
      if (state.recipientCopy[i].id == id) state.recipientCopy.splice(i, 1);
    }
  },
  removeElementFromAdministratingCopy(state, id) {
    for (let i = 0; i < state.administratingCopy.length; i++) {
      if (state.administratingCopy[i].id == id)
        state.administratingCopy.splice(i, 1);
    }
  },

  updateOrgsList(state, val) {
    state.organisationsList = val;
  },

  updateSelectedGrantLinksAndDocs(state, val) {
    var combinedArray = [...val.schemeLinks, ...val.schemeDocuments];
    combinedArray.sort((a, b) =>
      a.documentTypeDescription > b.documentTypeDescription ? 1 : -1,
    );
    state.sortedLinksAndDocs = combinedArray;
  },
  updateSelectedGrant(state, val) {
    state.selectedGrant = val;

    if (val.budget && val.budget.length > 130) {
      state.selectedGrant.shortBudget = val.budget.substring(0, 130);
      state.selectedGrant.shortBudgetTrans = "";
      state.selectedGrant.shortBudgetTrans = val.transBudget
        ? val.transBudget.substring(0, 130)
        : "";
    }
    store.commit("grantItems/updateSelectedGrantLinksAndDocs", val);
    state.fundingCopy = val.fundingOrganisations;
    state.advisingCopy = val.advisingOrganisations;
    state.recipientCopy = val.recipientOrganisations;
    state.administratingCopy = val.administratingOrganisations;
    state.selectedGrantMax = SchemeUtils.formatEuro(val.maxAmount);
    state.selectedGrantMin = SchemeUtils.formatEuro(val.minAmount);

    if (state.newsInLastYear.length > 0) state.newsInLastYear = [];
    if (state.olderNews.length > 0) state.olderNews = [];

    state.newsInLastYear = val.newsInLastYear;
    state.olderNews = val.olderNews;

    state.selectedTransBody = val.transBody;
    state.selectedTransApplicationProcedure = val.transApplicationProcedure;
    state.selectedTransIntroduction = val.transIntroduction;
    state.selectedTransCriteria = val.transCriteria;
    state.selectedTransFinancialinformation = val.transFinancialinformation;
    state.selectedTransName = val.transName;
    state.selectedTransApplicationInformation = val.transApplicationInformation;
    state.selectedTransBudget = val.transBudget;
    state.selectedTransDuration = val.transDuration;
  },
  updateTranslateScheme(state, val) {
    state.translateScheme = val;
  },
  enableModalError(state) {
    state.hasModalError = true;
  },
  disableModalError(state) {
    state.hasModalError = false;
  },
  updateModalError(state, message) {
    state.modalErrorMessage = message;
  },
  fillSchemeStatusOptions(state, val) {
    state.schemeStatuses = val;
  },
  fillTimeScopeOptions(state, val) {
    state.timeScopeOptions = val;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
